module.exports = __webpack_public_path__ + "img/gelin.554cc014.jpg";